/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   UNILINKD TUTORIAL CONTENT
   â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

   This is the ONLY file you need to edit to add or change tutorial content.
   No coding knowledge required   just edit the text inside quotes.

   â”€â”€ HOW TO ADD A NEW ARTICLE â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   1. Find the right category (e.g. the "managing-students" block below).
   2. Add a new article object inside its `articles: [ ... ]` array.
   3. Use this template   copy and paste it, then fill in the blanks:

        {
          id: 'my-new-article',        // Must be unique. Use lowercase-with-dashes.
          title: 'How to Do X',
          difficulty: 'Easy',          // Easy | Medium | Advanced
          time: '3 min',
          desc: 'One-line summary shown in the article list.',
          steps: [
            s("First, do this step."),
            s("Second step with a screenshot placeholder.", "Screenshot: What to show here"),
            s("Third step."),
          ],
        },

   â”€â”€ HOW STEPS WORK â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   Use the s() helper to write steps.

   Step without image:
     s("Do this thing.")

   Step with an image placeholder (grey box shown until you add a real screenshot):
     s("Do this thing.", "Screenshot: What you will see on screen")

   Step with a real screenshot (replace the placeholder text with a path):
     s("Do this thing.", "/screenshots/my-screenshot.png")

   â”€â”€ HOW TO ADD A VIDEO â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   To show a placeholder (video not ready yet):
     video: true

   To embed a real video file (.mov, .mp4, etc.):
     video: "/tutorial/my-video.mov"

   Put the video file in  frontend/public/tutorial/  and reference it with a
   leading slash. The video player appears at the top of the article with
   standard play/pause/fullscreen controls.

   â”€â”€ HOW TO LINK RELATED ARTICLES â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   Add  related: ['article-id-1', 'article-id-2']  to show links at the bottom.

   â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
   Questions? Ask your developer   they only need to add the article to the
   right category. Everything else is just filling in the text.
   â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */

// Step helper   do not change this function, just use it in your articles.
export const s = (text: string, image?: string) =>
  !image
    ? { text }
    : image.startsWith('/') || image.startsWith('http')
      ? { text, imageUrl: image }
      : { text, imagePlaceholder: image };

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// WEB DASHBOARD
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const DASHBOARD = {
  id: 'dashboard',
  title: 'Web Dashboard',
  subtitle: 'For Admins & Sub-Admins',
  audience: 'Admins, Sub-Admins, Super Admins, and Faculty',
  description:
    'Learn how to manage your institution from the UNILinkd web dashboard   enrolling teachers and students, setting up classrooms, managing departments, placements, and more.',
  categories: [
    {
      id: 'getting-started',
      title: 'Getting Started',
      description: 'Login, navigation, and understanding who can do what.',
      intro: 'The UNILinkd web dashboard is a browser-based management platform for your institution. It is used by Admins and Sub-Admins for day-to-day operations   enrolling users, managing departments, setting up classrooms. Faculty members also have limited access to view records and manage their assigned responsibilities. Everything here is scoped to your institution only   other colleges cannot see your data.',
      articles: [
        {
          id: 'what-is-institute-code',
          title: 'What is an Institute Code?',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Understand what the Institute Code is and why every login needs it.',
          related: [ 'how-to-login' ],
          steps: [
            s('Your Institute Code is a short unique code (e.g. "CLGX01") assigned to your college or university by UNILinkd. Think of it as the identifier for your entire institution inside the system.'),
            s('Every person at your institution who logs in   teachers, admins, students   must use this same Institute Code. It never changes unless your institution is re-registered.'),
            s('All your data (teachers, students, departments, classrooms) is stored under your Institute Code. Other institutions cannot see your data.', '/tutorial/signin-signup.png'),
            s('Your Institute Code is provided by the UNILinkd team when your institution is first onboarded. Whenever an admin adds a new teacher or student to the system, that person automatically receives an onboarding email from UNILinkd. This email contains their Institute Code, their ID (Employee ID or Roll Number), their Designation, and download links for the app   so they have everything they need to sign up without the admin having to share anything manually.', '/tutorial/onboarding-teacher.png'),
          ],
        },
        {
          id: 'how-to-login',
          title: 'How to Log In to the Dashboard',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Step-by-step sign-in guide for first-time users.',
          video: '/tutorial/dashboard-sign-in.mov',
          related: [ 'what-is-institute-code', 'understanding-roles' ],
          steps: [
            s('Open your web browser and Sign-In to the UNILinkd dashboard.', '/tutorial/toolbar-website.png'),
            s('You will see four fields. Fill them in this order: Institute Code   User ID   Email   Password.', '/tutorial/dashboard-sign-in-normal.png'),
            s('Institute Code   Your institution\'s unique code (same for everyone at your college). User ID   Your Employee ID as registered in the system (e.g. "TCHR-001" or "EMP-042").'),
            s('Email   The email linked to your account. Password   Your account password. Click "Sign In".', '/tutorial/signin-dashboard-guide-link.png'),
            s('If you see an error, double-check your Institute Code and User ID first   these are the most common mistakes.'),
          ],
        },
        {
          id: 'understanding-sidebar',
          title: 'Understanding the Sidebar and Navigation',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Learn how to move around the dashboard using the sidebar menu.',
          related: [ 'understanding-roles' ],
          steps: [
            s('After logging in, a dark sidebar appears on the left side of your screen. This is your main navigation panel.', '/tutorial/side-nav-dashboard.png'),
            s('At the top of the sidebar, your profile photo, name, Employee ID, and role badge (e.g. "ADMIN") are displayed.', '/tutorial/dashboard-profile.png'),
            s('The sidebar has expandable sections   Teachers, Students, Access Control   and individual module buttons: ClassRooms, Placements, Attendance, Departments, Clubs, Campus Library.'),
            s('Click any section name to expand it and see sub-options. The active selection is highlighted with a yellow left border.', '/tutorial/side-nav-dashboard-full.png'),
            s('Click the arrow button (â—€) at the top of the sidebar to collapse it for more screen space. Click again to expand.'),
            s('To sign out, scroll to the bottom of the sidebar and click "Sign Out".'),
          ],
        },
        {
          id: 'understanding-roles',
          title: 'Roles and Permissions Explained',
          difficulty: 'Easy',
          time: '6 min',
          desc: 'A full breakdown of every role on the faculty side   what each can and cannot do.',
          related: [ 'manage-admins' ],
          steps: [
            s('UNILinkd uses five roles for faculty and staff: Super Admin, Admin, Sub Admin, Faculty, and Librarian. Your role is assigned when your account is created and controls exactly what you can see and do in both the dashboard and the app. Your current role appears as a badge in the sidebar header.', 'Screenshot: Role badge highlighted in the sidebar header'),
            s('SUPER ADMIN   This is the highest role. A Super Admin has full, unrestricted access to every module and every action in the dashboard and app. Super Admins can create, modify, and delete any account   including other Admin accounts. They can manage teachers, students, classrooms, departments, placements, alumni, clubs, and the campus library. They can also assign and revoke admin roles. Typically held by the head of IT or the Principal.'),
            s('ADMIN   Admins have broad management access but cannot touch Super Admin accounts or other Admin accounts. An Admin can: add and delete teacher accounts (individually or in bulk via CSV), add and delete student accounts (individually or in bulk via CSV), create and manage classrooms, create and manage departments, post placements and revoke student access, manage alumni records, view and manage clubs, and create, modify, or delete Sub Admin accounts. Admins can also send private system messages to specific users via CSV upload. What Admins cannot do: create or modify other Admin accounts, change Super Admin settings.'),
            s('SUB ADMIN   Sub Admins have a similar scope to Admins but with key restrictions on deletion and account management. A Sub Admin can: add teacher and student accounts (individually or in bulk), update existing user details, create and manage classrooms, create and manage departments, manage placements and alumni. What Sub Admins cannot do: delete teacher or student accounts (only Admins and Super Admins can delete), create or modify Admin or Sub Admin accounts, change role assignments.'),
            s('FACULTY   Faculty members have a narrower scope focused on classroom and content management, not user administration. On the Dashboard, a Faculty member can: view the full list of teachers and students (read-only), submit attendance records via CSV upload, view and manage their assigned classroom\'s timetable and GMeet sessions, and view alumni records. On the Mobile App, faculty additionally get: submitting attendance directly from the app, posting in their department\'s announcement channel and the campus Bulletin, creating and managing clubs, creating note sets and sharing them with students via access code, and managing their assigned classrooms (GMeet, timetable, student export). What Faculty cannot do: add or delete user accounts, create classrooms or departments, create or manage placements, modify other admin or faculty accounts.'),
            s('LIBRARIAN   This is a purpose-built role for library staff. A Librarian has access to only the Campus Library module   they can add new books to the catalog, edit book details (author, genre, subject, available copies), and remove books that are no longer in stock. The Campus Library catalog is what students browse from the app to check physical book availability at your institution. Librarians cannot access any other module   they cannot view users, manage classrooms, submit attendance, or manage placements. Their dashboard is scoped entirely to the library.'),
            s('SUMMARY TABLE   Super Admin: full access everywhere. Admin: manage all users + modules, can delete, can manage Sub Admins. Sub Admin: manage all users + modules, cannot delete users or touch admin accounts. Faculty: view users, submit attendance, manage their assigned classroom, create content (notes, clubs, announcements)   cannot manage users or create departments/classrooms. Librarian: campus library catalog only. If a button or option is missing from your view, your role does not permit it. Contact a Super Admin to request a role change.', 'Screenshot: Role permission comparison table in the Access Control section'),
          ],
        },
      ],
    },
    {
      id: 'managing-teachers',
      title: 'Managing Teachers',
      description: 'View, enroll, and remove teacher accounts.',
      intro: 'Teacher accounts give faculty members access to the UNILinkd dashboard and mobile app. Admins can enroll teachers in bulk using an Excel or CSV file, or add them one at a time. An enrolled teacher is "Not Onboarded" until they log into the mobile app for the first time   that first login activates their account. Admins can also send private system messages to teachers and delete their accounts when needed.',
      articles: [
        {
          id: 'view-all-teachers',
          title: 'How to View All Teachers',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Browse and search the full list of registered teachers.',
          steps: [
            s('In the sidebar, click "Teachers"   "Show Teachers".', '/tutorial/expanded-teacher-view.png'),
            s('A table loads showing all teachers: name, Employee ID, email, department, role, and onboarding status.', '/tutorial/show-teachers-dashboard.png'),
            s('Use the search bar at the top of the table to find a teacher by name or Employee ID.'),
            s('"Not Onboarded" means the teacher\'s record exists in the system but they have not yet logged into the UNILinkd app for the first time.', '/tutorial/pending-verification.png'),
          ],
        },
        {
          id: 'add-teachers-bulk',
          title: 'How to Add Teachers in Bulk (CSV / Excel)',
          difficulty: 'Medium',
          time: '5 min',
          desc: 'Upload a spreadsheet to register multiple teachers at once.',
          video: '/tutorial/add-teacher.mov',
          related: [ 'add-teacher-individual', 'enroll-students-bulk' ],
          steps: [
            s('In the sidebar, click "Teachers"   "Add Teachers". The bulk upload panel opens.', '/tutorial/add-teacher.png'),
            s('Prepare your Excel or CSV file. It must have at least two columns: one for Employee ID (the unique identifier) and one for Email. Column header names can be anything   you will map them in the next step.'),
            s('Click "Choose File" and select your file. The system reads your column headers automatically.', '/tutorial/fake-employee-csv.png'),
            s('Primary Key dropdown   select the column that contains Employee IDs. This tells the system which column is the unique identifier for each teacher.', '/tutorial/bulk-employee-id.png'),
            s('Email Column dropdown   select the column that contains email addresses.', '/tutorial/bulk-teacher-email.png'),
            s('Click "Upload". Both your file and a mapping config are uploaded together. Teachers appear in the system once processed.'),
          ],
        },
        {
          id: 'add-teacher-individual',
          title: 'How to Add a Single Teacher',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Register one teacher at a time using the individual form.',
          related: [ 'add-teachers-bulk' ],
          steps: [
            s('In the sidebar, click "Teachers"   "Add Teachers", then click the "Add Individual" tab.', '/tutorial/add-teacher-single.png'),
            s('Enter the teacher\'s Employee ID (e.g. "EMP-2024-042") and their Email Address.'),
            s('Click "Add Teacher". A success message confirms the addition. The form clears so you can add another immediately.'),
          ],
        },
        {
          id: 'delete-teachers',
          title: 'How to Delete Teachers',
          difficulty: 'Medium',
          time: '3 min',
          desc: 'Remove one or multiple teachers from the system.',
          steps: [
            s('In the sidebar, click "Teachers"   "Delete Teachers". This option is only visible to Admins and above.', '/tutorial/delete-teacher-bulk.png'),
            s('Upload a CSV or XLSX file with the Employee IDs of teachers to remove. Select the Primary Key column that contains those IDs.'),
            s('Click "Upload". The listed teachers will be removed. This cannot be undone   double-check your file before uploading.'),
          ],
        },
        {
          id: 'send-private-message-teachers',
          title: 'How to Send Private Messages to Teachers (CSV)',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Send system messages to specific teachers via CSV upload.',
          related: [ 'send-private-message-students' ],
          steps: [
            s('In the sidebar, click "Teachers"   "Message". This opens the CSV messaging panel.', '/tutorial/teacher-bulk-messaging=excel.png'),
            s('Private messages in UNILinkd are system-generated messages delivered directly to specific users. They cannot reply   it is one-way communication from the institution.'),
            s('Prepare a CSV file with the Employee IDs of teachers to message. Upload the file and select the Primary Key column.', '/tutorial/bulk-teacher-message.png'),
            s('Click "Upload". The message will be delivered to each listed teacher\'s private messages in the app.'),
          ],
        },
      ],
    },
    {
      id: 'managing-students',
      title: 'Managing Students',
      description: 'Enroll, view, and manage student accounts and departments.',
      intro: 'Student accounts give students access to the UNILinkd mobile app   attendance reports, classroom chats, the placement portal, clubs, and the e-library. Admins enroll students via CSV or one at a time. A newly enrolled student is "Not Onboarded" until they log into the app for the first time, which activates their account fully. Each student can belong to only one department; an Admin must reset it if they need to change.',
      articles: [
        {
          id: 'view-all-students',
          title: 'How to View All Students',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Browse and search the full student list.',
          steps: [
            s('In the sidebar, click "Students"   "Show Students".', '/tutorial/manage-students.png'),
            s('A table loads with all enrolled students: name, Roll Number, email, department, and onboarding status.', '/tutorial/student-table.png'),
            s('Use the search bar to find a student by name or Roll Number. The table filters as you type.'),
          ],
        },
        {
          id: 'enroll-students-bulk',
          title: 'How to Enroll Students in Bulk (CSV / Excel)',
          difficulty: 'Medium',
          time: '5 min',
          desc: 'Upload a spreadsheet to register multiple students at once.',
          video: '/tutorial/add-student.mov',
          related: [ 'enroll-student-individual', 'what-is-not-onboarded' ],
          steps: [
            s('In the sidebar, click "Students"   "Add Students".', '/tutorial/manage-students.png'),
            s('Prepare your Excel or CSV file with at least two columns: Roll Number (unique student ID) and Email. Column header names can be anything you choose.', '/tutorial/student-add-fake-excel.png'),
            s('Click "Choose File" and select your file. The system reads your column headers automatically.'),
            s('Primary Key dropdown   select the column that contains Roll Numbers.', '/tutorial/student-add-primary-key.png'),
            s('Email Column dropdown   select the column with email addresses.', '/tutorial/student-add-email.png'),
            s('Click "Upload". Students are added to the system. Each student will show "Not Onboarded" until they log into the app for the first time.'),
          ],
        },
        {
          id: 'enroll-student-individual',
          title: 'How to Enroll a Single Student',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Register one student at a time using the individual form.',
          related: [ 'enroll-students-bulk' ],
          steps: [
            s('In the sidebar, click "Students"   "Add Students", then click the "Add Individual" tab.', '/tutorial/manage-students.png'),
            s('Enter the student\'s Roll Number (e.g. "STU-2024-001") and their Email Address.', '/tutorial/add-student-single.png'),
            s('Click "Add Student". A success message confirms. The form clears so you can add another.'),
          ],
        },
        {
          id: 'delete-students',
          title: 'How to Delete Students',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Remove students and optionally move them to the alumni directory.',
          related: [ 'view-alumni' ],
          steps: [
            s('In the sidebar, click "Students"   "Delete Students".', '/tutorial/manage-students.png'),
            s('Upload a CSV or XLSX file with the Roll Numbers to remove. Select the Primary Key column.', '/tutorial/student-add-fake-excel.png'),
            s('"Add to Alumni Directory" toggle   if turned ON, deleted students are moved to the Alumni section instead of being permanently removed. Recommended for graduating students.', '/tutorial/del-student-bulk.png'),
            s('Click "Upload". This cannot be undone   verify your file before uploading.'),
          ],
        },
        {
          id: 'what-is-not-onboarded',
          title: 'What Does "Not Onboarded" Mean?',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Understand the difference between an enrolled account and an active account.',
          related: [ 'enroll-students-bulk' ],
          steps: [
            s('When you enroll a student or teacher, their record is created   but the account is not active yet.'),
            s('"Not Onboarded" means the person has been enrolled by an admin but has not logged into the UNILinkd app for the first time.', '/tutorial/pending-verification.png'),
            s('Once they download the app and sign in using their Roll Number and password, the account becomes active   status changes to "Onboarded".'),
            s('Some features   such as the Placement Portal   only work for Onboarded users. If a student reports they cannot access a feature, check their onboarding status first.'),
          ],
        },
        {
          id: 'reset-student-department',
          title: 'How to Reset a Student\'s Department',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Clear a student\'s department so they can select a new one in the app.',
          steps: [
            s('Students can only belong to ONE department. If a student joined the wrong department or needs to transfer, an admin must reset it from the dashboard.'),
            s('In the sidebar, click "Students"   "Reset Departments".', '/tutorial/manage-students.png'),
            s('To reset a single student: click "Reset Single Student", enter their Roll Number, and click "Reset".', '/tutorial/reset-department-single.png'),
            s('To reset multiple students at once: upload a CSV file with their Roll Numbers and select the Primary Key column, then click "Upload".', '/tutorial/reset-dep-bulk.png'),
            s('Once reset, the student is allowed to re-select the department.'),
          ],
        },
        {
          id: 'send-private-message-students',
          title: 'How to Send Private Messages to Students (CSV)',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Send system messages to specific students via CSV upload.',
          related: [ 'send-private-message-teachers' ],
          steps: [
            s('In the sidebar, click "Students"   "Message". This opens the CSV messaging panel.', '/tutorial/manage-students.png'),
            s('Private messages are one-way system messages delivered directly to a student\'s private inbox in the app. Students cannot reply.', '/tutorial/student-bulk-msg-excel.png'),
            s('Prepare a CSV file with the Roll Numbers of students to message. Upload it and select the Primary Key column.', '/tutorial/bulk-msg-student-full.png'),
            s('Click "Upload". The message is delivered to each listed student\'s private messages in the app.'),
          ],
        },
      ],
    },
    {
      id: 'subjects',
      title: 'Subjects',
      description: 'Maintain the shared list of subject codes and names used across attendance and timetables.',
      intro: 'The Subject Registry is a single shared list of subject codes and names for your institution   for example "CS301   Data Structures". It exists so that classroom timetables and attendance registers always reference the exact same subject, instead of every faculty member typing a slightly different name each time. Any authenticated Faculty or Student can browse the registry (read-only); only Admins, Sub-Admins, and Super Admins can add, edit, or delete subjects.',
      articles: [
        {
          id: 'manage-subjects',
          title: 'How to Manage the Subject Registry',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Add, edit, and remove the subject codes used across attendance and timetables.',
          related: [ 'take-attendance-dashboard', 'create-timetable' ],
          steps: [
            s('In the sidebar, click "Subjects". You will see every subject currently registered, with its code, name, and who added it.', 'Screenshot: Subject Registry table'),
            s('Click "Add Subject" to create one. Toggle "Bulk add" to paste in up to 50 subjects at once instead of adding them one at a time.', 'Screenshot: Add Subject dialog with Single/Bulk toggle'),
            s('Enter a Subject Code (required) and an optional Subject Name, then click "Save" (or "Add All" in bulk mode).'),
            s('Use "Edit" to correct a code or name, or the trash icon to delete a subject that is no longer needed   existing attendance registers and timetable entries that already reference it are not affected.'),
            s('Search by code or name to quickly find a subject once the list grows.'),
          ],
        },
      ],
    },
    {
      id: 'attendance',
      title: 'Attendance',
      description: 'Take, review, and export attendance registers   tied to real subjects and classrooms.',
      intro: 'The Attendance Registry replaces manual attendance sheets and spreadsheet uploads. Faculty take attendance for a specific classroom, subject, and date   either from the mobile app or directly from the dashboard   marking each student present or absent. Every register is tied to a real subject from the Subject Registry, so a student\'s attendance report is always broken down subject-by-subject. Faculty and Admins can review, filter, edit, sync, and delete registers from the dashboard, see live summary stats, and request a CSV/Excel export emailed to them.',
      articles: [
        {
          id: 'take-attendance-dashboard',
          title: 'How to Take Attendance from the Dashboard',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Mark a class present/absent for a specific classroom, subject, and date.',
          related: [ 'review-export-attendance', 'manage-subjects' ],
          steps: [
            s('In the sidebar, click "Attendance". Click "Take Attendance".', 'Screenshot: Attendance Registry page with the Take Attendance button highlighted'),
            s('Select the classroom the lecture was for, then select the subject taught   subjects come from your institution\'s Subject Registry, searchable by code or name.', 'Screenshot: Classroom and subject pickers'),
            s('Pick the lecture date (defaults to today) and optionally a period.'),
            s('The full class roster appears. Use "Mark all present" or "Mark all absent" as a starting point, then search by name or ID to fine-tune individual students.', 'Screenshot: Roster with present/absent checkboxes'),
            s('Click "Submit Attendance". The register is saved immediately, and every marked student\'s subject-wise attendance updates right away in their app.'),
          ],
        },
        {
          id: 'review-export-attendance',
          title: 'How to Review, Edit, and Export Attendance Registers',
          difficulty: 'Medium',
          time: '5 min',
          desc: 'Filter past registers, correct a mistake, and export attendance data to a file.',
          related: [ 'take-attendance-dashboard' ],
          steps: [
            s('In the sidebar, click "Attendance". This shows every register taken at your institution, with summary cards for lectures taken, roster instances, total absences, and overall attendance percentage.', 'Screenshot: Attendance Registry summary cards'),
            s('Filter the list by classroom, subject, or a date range. Click "Clear" to reset all filters.'),
            s('Each register row shows its sync status. If a register shows as not synced, click "Sync" to retry pushing it to students\' apps.'),
            s('Click "View" on any register to open its full detail   the complete roster with who was marked present or absent.', 'Screenshot: Register detail dialog'),
            s('To fix a mistake, click "Edit" inside the detail view, change the classroom, subject, date, or individual present/absent marks, and click "Save Changes".'),
            s('Click "Export Register" to generate a CSV/Excel file for a classroom, subject, or date range   you\'ll get an email with a download link once it\'s ready (valid for 2 days).', 'Screenshot: Export Register dialog'),
            s('Made a register by mistake? Click the trash icon on its row and confirm to delete it.'),
          ],
        },
      ],
    },
    {
      id: 'classrooms',
      title: 'Classrooms',
      description: 'Create classrooms, assign teachers, and build timetables   replacing WhatsApp groups.',
      intro: 'Classrooms in UNILinkd replace the need for separate WhatsApp groups for every class batch. Each classroom has a dedicated group chat for students and their assigned teacher, a weekly timetable, Google Meet integration for online sessions, and an exportable student list. Classrooms are created from the dashboard by Admins or Sub-Admins and assigned to a faculty incharge who manages them. Each period in a timetable can also have a subject teacher assigned (this is optional), and there is a dedicated Teaching Schedule page to see who is teaching what, and when, across every classroom.',
      articles: [
        {
          id: 'create-classroom',
          title: 'How to Create a Classroom',
          difficulty: 'Medium',
          time: '5 min',
          desc: 'Create a classroom for a class batch and assign it to a faculty incharge.',
          steps: [
            s('Classrooms are created from the dashboard by Admins and Sub-Admins. Once created, they appear in the app for the assigned teacher and students.', '/tutorial/classrooms.png'),
            s('In the sidebar, click "ClassRooms". Click "Create Classroom".', '/tutorial/create-classroom.png'),
            s('Enter the classroom name (e.g. "B.Sc CS Sem 4") and assign a faculty incharge   the teacher responsible for this class.', 'Screenshot: Create classroom form with name and incharge fields'),
            s('Students and teachers can message in the classroom. No need for separate WhatsApp groups   the classroom keeps all communication in one organized place.'),
            s('Click "Save". The classroom appears in the app for the assigned incharge teacher.'),
          ],
        },
        {
          id: 'create-timetable',
          title: 'How to Set Up a Timetable',
          difficulty: 'Medium',
          time: '7 min',
          desc: 'Build a weekly timetable for a classroom, and optionally assign a subject teacher to each period.',
          steps: [
            s('Timetables can be created by any Faculty account   not just the classroom\'s incharge.'),
            s('Open the ClassRooms module, select a classroom, and click "Timetable".', 'Screenshot: ClassRooms list with the Timetable button highlighted'),
            s('The editor shows a weekly grid. Search for a subject in the "Search & add a subject" box below the grid   it gets added as a draggable chip. Drag the chip onto any period cell to schedule it.', 'Screenshot: Subject search box with a draggable subject chip'),
            s('Assigning a subject teacher is optional. Use the second "Search & add a teacher" box the same way   search by name (their photo is shown alongside the result to help tell people with similar names apart), then drag the teacher chip onto a period. A period can have a subject with no teacher, a teacher with no subject, or both.', 'Screenshot: Teacher search box with profile photos in the results, and a teacher chip being dragged onto a cell'),
            s('You can remove just the teacher from a period without removing the subject   hover the period and click the small X next to the teacher\'s name.'),
            s('Click "Save Timetable". If a teacher you just assigned is already teaching a different classroom at an overlapping day and time, a "Scheduling conflict detected" report appears listing every clash in full detail. You can Cancel and adjust the timetable, or click "Proceed Anyway" to save it as-is.', 'Screenshot: Scheduling conflict detected dialog listing the clashing classes'),
            s('Once saved, students in that classroom see the timetable in the app, and any assigned teacher\'s class shows up automatically in their own Teaching Schedule.'),
          ],
          related: ['teaching-schedule'],
        },
        {
          id: 'teaching-schedule',
          title: 'How to View Teaching Schedules',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'See your own weekly teaching schedule, or look up a colleague\'s, across every classroom.',
          steps: [
            s('In the sidebar, click "Teaching Schedule". By default this shows your own schedule   every period across every classroom where you are assigned as the subject teacher.', 'Screenshot: Teaching Schedule sidebar link and the weekly calendar for the logged-in faculty member'),
            s('The schedule is shown as a weekly calendar, with hours down the side and days across the top, the same way a personal calendar app looks. Each class is color-coded by classroom so a recurring class is easy to recognize at a glance.'),
            s('To look up a colleague\'s schedule instead, use the "View a colleague\'s schedule" search box at the top and select their name. Click "Back to my schedule" to return to your own. This is only available on the web dashboard, not in the app.', 'Screenshot: Colleague search box with a colleague\'s schedule shown'),
            s('If the same faculty member is scheduled in two different classrooms at an overlapping time, both classes are merged into one red cell labeled "N clashing classes" instead of overlapping each other. Click the cell to expand it and see the full detail of every clash, or click again to collapse it.', 'Screenshot: Expanded scheduling conflict cell listing the clashing classes'),
            s('A conflict here means the timetables were saved with an overlap   either it was intentional (e.g. temporary co-teaching), or someone clicked "Proceed Anyway" on the warning shown when saving a timetable. Contact your institution\'s admin to resolve a conflict that shouldn\'t be there.'),
          ],
          related: ['create-timetable'],
        },
        //{
        //  id: 'export-classroom-students',
        //  title: 'How to Export Classroom Student Information',
        //  difficulty: 'Easy',
        //  time: '2 min',
        //  desc: 'Download the list of students in a classroom as a file.',
        //  steps: [
        //    s('Open a classroom from the ClassRooms module.', '/tutorial/timetable-1.png'),
        //    s('Click the "Export" option. A file will download with the names, Roll Numbers, and contact details of all students in that classroom.', '/tutorial/timetable-2.png'),
        //    s('This is useful for attendance sheets, exam seating arrangements, or sharing student lists with external departments.'),
        //  ],
        //},
      ],
    },
    {
      id: 'departments',
      title: 'Departments',
      description: 'Create academic departments that students can join in the app.',
      intro: 'Departments are the primary academic grouping unit in UNILinkd   for example, "B.Sc Computer Science Batch 2024". Each student belongs to exactly one department (they cannot join multiple). Departments have their own announcement channel in the app where faculty can broadcast messages exclusively to that batch. Departments are created by Admins and Sub-Admins from the dashboard; faculty members can join multiple departments to stay connected with different batches.',
      articles: [
        {
          id: 'create-department',
          title: 'How to Create a Department',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Create a department that students can join   each student can only be in one.',
          steps: [
            s('Departments are created by Admins and Sub-Admins from the dashboard. Faculty cannot create departments.', '/tutorial/departments.png'),
            s('In the sidebar, click "Departments". Click "Create Department".', '/tutorial/create-department.png'),
            s('Enter the department name (e.g. "B.Com   Batch 2024"). Click Save.'),
            s('Students will see this department when they open the app and can request to join. Important: each student can only belong to ONE department at a time. If they need to change, an admin must reset their department from the Students section.'),
            s('Faculty members can join multiple departments to stay connected with different batches.'),
          ],
        },
      ],
    },
    {
      id: 'placements',
      title: 'Placements',
      description: 'Post job listings and manage student placement access.',
      intro: 'The Placement Portal is UNILinkd\'s built-in campus career system. Admins and Sub-Admins create verified job and internship listings from the dashboard. Students browse and apply directly through the mobile app   they can also track their applications and withdraw. Faculty can only view listings, not apply. Admins can revoke a student\'s ability to apply   for example, if they have already accepted an offer and should not sit in further placement drives.',
      articles: [
        {
          id: 'create-job-listing',
          title: 'How to Create a Job or Internship Listing',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Post a new job or internship opportunity for students to apply to.',
          steps: [
            s('Job listings are created from the dashboard by Admins and Sub-Admins. Faculty cannot create listings.', '/tutorial/placement.png'),
            s('In the sidebar, click "Placements". Click "Add Listing".', '/tutorial/create-placement.png'),
            s('Fill in the job details: company name, role, employment type (full-time / internship), work mode (remote / on-site / hybrid), description, and deadline.'),
            s('Click "Publish". The listing appears in the Placement Portal for all Onboarded students to browse and apply.'),
          ],
        },
        {
          id: 'revoke-placement-access',
          title: 'How to Revoke a Student\'s Placement Access',
          difficulty: 'Medium',
          time: '3 min',
          desc: 'Block a student from applying to further jobs (e.g. if they already have an offer).',
          related: [ 'what-is-not-onboarded' ],
          steps: [
            s('If a student has accepted a job offer and should no longer apply for other roles, you can revoke their placement access.'),
            s('Go to "Students"   "Show Students". Find the student in the table.'),
            s('In the "Placement Access" column, click the status chip next to their name and select "Revoke".', '/tutorial/revoke-placement.png'),
            s('The student will no longer be able to apply for any job listing. Note: this only works for Onboarded students   unverified students do not have placement access anyway.'),
            s('To restore access later, click the same chip and select "Restore".'),
          ],
        },
      ],
    },
    {
      id: 'campus-library',
      title: 'Campus Library',
      description: 'Manage your institution\'s physical library catalog   managed by the Librarian role.',
      intro: 'The Campus Library module is a digital catalog of your institution\'s physical book collection. Students can search the catalog from the mobile app   by title, author, genre, or subject   to check availability before visiting in person. This module is managed by the Librarian role, a dedicated account type for library staff. Admins and Sub-Admins can also manage it. This is separate from the E-Library, which is UNILinkd\'s own digital content platform.',
      articles: [
        {
          id: 'manage-library-catalog',
          title: 'How to Manage the Library Catalog',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Add and update book records in your institution\'s library catalog.',
          steps: [
            s('The Campus Library catalog is managed by the Librarian role. Admins and Sub-Admins can also manage it.'),
            s('In the sidebar, click "Campus Library". You will see the list of books currently in your institution\'s physical collection.', '/tutorial/campus-lib-table.png'),
            s('Students can browse this catalog in the app by genre, author, or subject to find books available in your campus library.'),
            s('To add a book, click "Add Book" and fill in: title, author, genre, subject, and number of available copies.', '/tutorial/add-books.png'),
            s('To update or remove an existing entry, find the book in the list and use the Edit or Delete options.'),
          ],
        },
      ],
    },
    {
      id: 'clubs',
      title: 'Clubs',
      description: 'Manage campus clubs   created by faculty, accessible to all students.',
      intro: 'Clubs are UNILinkd\'s community feature   think of each club as a university-wide interest board, similar to a subreddit, for groups like the Coding Club, Debate Society, or Art Club. Only Faculty can create clubs (from the mobile app). Students can discover and join clubs freely, and depending on club settings, post and comment. All club posts are automatically removed after 6 months. From the dashboard, Admins can view and oversee all active clubs.',
      articles: [
        {
          id: 'manage-clubs-dashboard',
          title: 'How to Manage Clubs from the Dashboard',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'View and oversee clubs active at your institution.',
          steps: [
            s('In the sidebar, click "Clubs". You will see all active clubs with their member counts and status.'),
            s('Clubs work like a university-wide Reddit   each club is a community where members can browse and interact with posts. Post content is retained for 6 months before being automatically cleared.'),
            s('Clubs are created by Faculty from the mobile app (not the dashboard). From the dashboard, admins can view and oversee all clubs.', '/tutorial/clubs-list.png'),
          ],
        },
      ],
    },
    {
      id: 'alumni',
      title: 'Alumni Management',
      description: 'Manage your institution\'s alumni records.',
      intro: 'The Alumni module maintains a permanent directory of former students. Alumni are added automatically when students are removed with the "Add to Alumni" toggle turned on, or they can be added manually. Alumni can submit an update survey to share their current employment, location, and contact details   helping the institution keep its alumni network current. Admins and Sub-Admins can add, edit, and delete alumni records; Faculty can only view them.',
      articles: [
        {
          id: 'view-alumni',
          title: 'How to View and Manage Alumni',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Access the alumni directory and manage alumni profiles.',
          related: [ 'delete-students' ],
          steps: [
            s('In the sidebar, click "Students"   "Manage Alumni".', '/tutorial/manage-students.png'),
            s('The alumni page shows users who were moved to the alumni directory   either via the "Add to Alumni" toggle during student deletion.', '/tutorial/alumni-list.png'),
            s('Each entry shows name, Roll Number, and any other details submitted. Faculty can read alumni records. Admins and Sub-Admins can also add, update, and delete alumni entries.'),
          ],
        },
        {
          id: 'alumni-survey',
          title: 'How to Use the Alumni Survey',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Collect updated employment and personal details from alumni.',
          steps: [
            s('The Alumni Survey is a shareable form that alumni can fill in to update their current employment status, location, and contact details.', '/tutorial/alumni-email.png'),
            s('Share the survey link with your alumni via email or other channels. Responses appear automatically in the alumni management section.', '/tutorial/alumni-survey.png'),
          ],
        },
      ],
    },
    {
      id: 'access-control',
      title: 'Access Control & Roles',
      description: 'Manage admin accounts and role assignments.',
      intro: 'Access Control manages the hierarchy of administrative power at your institution. Each role in UNILinkd has a specific set of permissions   from the Super Admin who has full control, to Faculty who can only view records and submit attendance. Only Super Admins can create or modify Admin accounts. This section lets you view who currently has elevated access and manage their roles.',
      articles: [
        {
          id: 'manage-admins',
          title: 'How to Add and Manage Admin Accounts',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Create Admin and Sub-Admin accounts   requires Super Admin access.',
          related: [ 'understanding-roles' ],
          steps: [
            s('In the sidebar, click "Access Control" to expand it. You will see three options: Admins, Sub Admins, Super Admin.', 'Screenshot: Access Control sub-menu expanded'),
            s('Click "Admins" to view all Admin-level users in your institution.', 'Screenshot: Admin list table'),
            s('Only Super Admins can create or modify Admin accounts. If you need to promote a faculty member to Admin, contact your Super Admin.'),
            s('Sub Admins are useful for department coordinators or senior staff who need management access but should not have full Admin control.', 'Screenshot: Sub-Admin list table'),
          ],
        },
      ],
    },
    {
      id: 'documents',
      title: 'Documents',
      description: 'Design certificate and document templates, and control who can download them.',
      intro: 'The Documents module lets Admins, Sub-Admins, and Super Admins design reusable document templates   certificates, bonafide letters, ID cards, and more   with a background image, editable text, and dynamic fields that auto-fill with each person\'s own name, email, and ID. Students and faculty then self-serve download their own copy from the mobile app\'s Library tab   no more manual certificate requests. Access can be left open to everyone in a role, or restricted to a specific list of IDs, and Students and Faculty are always controlled completely separately.',
      articles: [
        {
          id: 'create-document-template',
          title: 'How to Create a Document Template',
          difficulty: 'Medium',
          time: '6 min',
          desc: 'Design a certificate or letter template with a background, text, and dynamic fields.',
          related: [ 'document-access-control' ],
          steps: [
            s('In the sidebar, click "Documents".', '/tutorial/toolbar-updated-1.png'),
            s('Click "New Template" to open the template designer.', '/tutorial/documents-list.png'),
            s('Give the template a name (e.g. "Bonafide Certificate") and an optional description. Upload a background image   it is automatically compressed and resized on your device before upload, so a large photo won\'t bloat storage.', '/tutorial/create-document.png'),
            s('Use the toolbar to add elements onto the canvas: free Text, a Blank Line (for a signature or a manual-fill blank), or one of three Wildcards   {User Name}, {User Email}, {User ID}. Wildcards automatically fill in with each person\'s own details when they download.'),
            s('Drag elements to position them, and use the corner/edge handles to resize. Use the inspector panel on the right to set font, size, bold/italic, alignment, and color for whichever element is selected.'),
            s('Click "Preview" at any time to see the template rendered with sample data, and use the Print button there to test the final printed output.'),
            s('Click "Save Template" when done. New templates default to open access for both Students and Faculty   use Access Control to restrict who can download it.'),
          ],
        },
        {
          id: 'document-access-control',
          title: 'How to Control Who Can Download a Document',
          difficulty: 'Medium',
          time: '5 min',
          desc: 'Set a document to Open or Restricted access, and manage the allowed list.',
          related: [ 'create-document-template' ],
          steps: [
            s('Student and Faculty access are controlled completely separately for every document   restricting it for Students has no effect on Faculty, and vice versa.'),
            s('From the Documents list, click the Access Control icon on a template. This opens a full-screen panel with a tab for Students and a tab for Faculty.', '/tutorial/document-access-control.png'),
            s('Each tab has a "Restricted Access" switch. Off (Open) means anyone in that role can download it. On (Restricted) means only the IDs you explicitly grant below can.'),
            s('Add people individually by User ID / E_id, or upload a CSV/Excel list for bulk add   both stage the change rather than applying it immediately. Bulk delete works the same way, via its own file upload.'),
            s('The granted list is paginated and searchable by exact ID   useful once a list has grown to hundreds or thousands of people. Select multiple rows to remove them together, or use "Clear All" to remove everyone (always asks for confirmation first).'),
            s('Nothing is sent to the server as you make changes   everything is staged locally first. Review the full summary of what will change and click "Confirm & Apply" to save it as a single request.'),
          ],
        },
      ],
    },
    {
      id: 'ai-guide',
      title: 'AI-Guide',
      description: 'Publish News & Updates and General Info content that students and faculty can ask UniAI about.',
      intro: 'AI-Guide lets Admins and Super Admins publish two kinds of institution-wide content   News & Updates (announcements, deadlines, events) and General Info (policies, facilities, contacts)   that any student or faculty member can then ask about directly inside the UniAI chat screen\'s "Guide" mode on the mobile app. There is one live document per category; saving a new version replaces the previous one. This is purely a content-management tool on the dashboard   the guide itself is only read and asked about from the mobile app.',
      articles: [
        {
          id: 'publish-ai-guide-content',
          title: 'How to Publish News & Updates and General Info',
          difficulty: 'Easy',
          time: '4 min',
          desc: 'Write and publish the content UniAI\'s Guide mode answers questions from.',
          steps: [
            s('In the sidebar, click "AI-Guide". You will see two sections: News & Updates and General Info.', '/tutorial/toolbar-updated-1.png'),
            s('Each section holds a single document. Click into a section, write or edit the content, and click Save   this becomes the current live version immediately, replacing whatever was published before it.', '/tutorial/ai-guide.png'),
            s('Keep content accurate and up to date (e.g. "Registration closes February 14")   UniAI\'s Guide mode answers student and faculty questions using exactly what is written here.'),
            s('Only Admins and Super Admins can publish or edit this content. Any authenticated student or faculty member can read it via UniAI, no separate permission needed on their side.'),
          ],
        },
      ],
    },
  ],
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// MOBILE APP   FACULTY
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const APP_MOBILE = {
  id: 'app-mobile',
  title: 'Mobile App',
  subtitle: 'For Faculty & Students',
  audience: 'Faculty and Students using the UNILinkd mobile app',
  description:
    'Everything you need to use the UNILinkd mobile app   whether you are faculty or a student. Covers messaging, groups, classrooms, attendance, clubs, the library, placement, and AI tools.',
  categories: [
    {
      id: 'getting-started',
      title: 'Getting Started',
      description: 'Download the app, log in, and understand your navigation.',
      intro: 'The UNILinkd app is available on Android and iOS for both faculty and students. This section covers account setup, first login, and navigating the app   follow the guide for your role. Faculty get additional tools including attendance submission, note creation, Google Meet integration, and announcement posting. Students have access to messaging, clubs, classrooms, the placement portal, and AI study tools.',
      articles: [
        {
          id: 'app-signup',
          title: 'How to Create Your Account',
          difficulty: 'Easy',
          time: '5 min',
          desc: 'Set up your UNILinkd account for the first time. Works for both faculty and students.',
          video: false,
          related: [ 'app-login', 'join-department' ],
          steps: [
            s('Before you start: check your email inbox for a message from UNILinkd with the subject "You\'ve been added to your institution". It contains your Institute Code, your ID, your Designation, and app download links. Keep it open.', '/tutorial/signup-mobile.png'),
            s('Download the app using the link in the email, or search "UNILinkd" on the Google Play Store (Android) or Apple App Store (iOS).'),
            s('Open the app and tap "Get Started" or "Sign Up".'),
            s('Enter your Institute Code and your ID from the onboarding email. Then tick your role: tap Faculty if you are a teacher or staff member, or tap Student if you are a student. Faculty use their Employee ID as the ID; students use their Roll Number.', 'Screenshot: Signup form showing Institute Code, ID field, and Faculty or Student selection'),
            s('Enter your full name and create a password. Tap "Sign Up".'),
            s('A verification email will be sent to your registered email address. Go to that inbox now.', '/tutorial/mobile-verification.png'),
            s('Find the new email from UNILinkd and tap "Verify Email". This activates your account.', '/tutorial/verification-email.png'),
            s('Return to the app and tap "I have verified my email". You will be logged in automatically.'),
          ],
        },
        {
          id: 'app-login',
          title: 'How to Log In',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Sign in to your UNILinkd account after it is already set up.',
          video: false,
          related: [ 'app-signup', 'join-department' ],
          steps: [
            s('Open the UNILinkd app and tap "Sign In".'),
            s('Enter your Institute Code, your ID (Employee ID for faculty, Roll Number for students), and your password. Tap "Sign In".'),
            s('You are now signed in. All features for your role are available.'),
          ],
        },
        {
          id: 'join-department',
          title: 'How to Join Your Department',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Students: select your academic department on first login.',
          steps: [
            s('On first login, the app will prompt you to select your department (e.g. "B.Sc Computer Science, Batch 2024").', '/tutorial/departments-blank.png'),
            s('You can only belong to ONE department. Choose carefully. If you pick the wrong one, ask your faculty admin to reset your department assignment.', '/tutorial/departments-list.png'),
            s('Once selected, you are added to that department\'s group and will see department-specific announcements and content. Please note that Students can only select single department while Faculty members can join multiple .'),
            s('You can also use side-navigation menu to browse and join departments . ', '/tutorial/departments-side-nav.png'),
          ],
        },
        {
          id: 'app-navigation',
          title: 'Navigating the App',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Understand the bottom tabs and the side drawer.',
          steps: [
            s('The app has four main tabs at the bottom: Chats (direct messages), Groups (group chats and channels), Clubs (community boards), Library (notes, classrooms, e-library, campus library, placements, attendance, subjects).', '/tutorial/navigating-app.png'),
            s('Tap the menu icon (hamburger icon at the top-left) to open the side drawer. This has: Drawers (media folders), UniAI, and Settings.', '/tutorial/side-nav-mobile.png'),
            s('In the Library tab: Faculty additionally see "Attendance Registry" for taking and reviewing attendance. Students see "Attendance" to view their own report. Everyone sees "Subjects" to browse the subject list.'),
          ],
        },
      ],
    },
    {
      id: 'messaging',
      title: 'Direct Messages & User Search',
      description: 'Find anyone at your institution and send direct messages.',
      intro: 'Direct messages are private one-on-one conversations between any two registered users at your institution. Search for anyone by name   a professor, student, or colleague   and message them without needing a phone number. Files, images, voice messages, and documents can all be shared in a DM. This is the primary channel for personal academic communication on UNILinkd.',
      articles: [
        {
          id: 'how-to-dm',
          title: 'How to Send a Direct Message',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Start a private one-on-one conversation with anyone at your institution.',
          steps: [
            s('Tap the "Chats" tab. Tap the search or compose icon.'),
            s('Search by name — you can find any registered student or staff member at your institution.', '/tutorial/searched-contacts-mobile.png'),
            s('Add user to open a chat. Type your message and tap Send.', '/tutorial/normal-chat.png'),
            s('Share files by tapping the attachment icon (📎) — choose Image, Document, Video, or Audio. Hold the microphone icon to send a voice message.', '/tutorial/chat-attachments.png'),
          ],
        },
      ],
    },
    {
      id: 'groups-channels',
      title: 'Groups & Channels',
      description: 'Join and create group conversations   both faculty and students can create groups.',
      intro: 'Groups work like WhatsApp group chats but within UNILinkd   any registered user at your institution can join with a group code or be added directly. Both faculty and students can create groups. Channels are optional topic threads inside a group, letting you separate conversations by subject, project, or purpose. Super Groups are one-way broadcast spaces where only the creator can post   ideal for large-scale announcements.',
      articles: [
        {
          id: 'join-group-code',
          title: 'How to Join a Group Using a Group Code',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Enter a group code shared by a teacher or classmate to join a group.',
          steps: [
            s('Tap the "Groups" tab. Tap "Join with Code" or the join option.', '/tutorial/groups-menu-1.png'),
            s('Enter the Group Code shared by whoever created the group. Tap "Join".', '/tutorial/group-code.png'),
            s('You are now a member. You can read and send messages in the group and any of its channels.'),
          ],
        },
        {
          id: 'create-group',
          title: 'How to Create a Group',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Start a group conversation   like a WhatsApp group but inside UNILinkd.',
          steps: [
            s('Tap the "Groups" tab. Tap the "+" button to create a new group.', '/tutorial/groups-menu-1.png'),
            s('Give the group a name and add members by searching their names or Roll/Employee Numbers. Tap "Create".', '/tutorial/create-group.png'),
            s('Once created, share the Group Code with anyone at your institution   they can use it to join the group without being individually added.', '/tutorial/group-code-profile.png'),
          ],
        },
        {
          id: 'add-channel',
          title: 'How to Add Channels to a Group',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Create topic-specific threads inside a group   optional but powerful for organization.',
          steps: [
            s('Open a group you created. Tap "Add Channel" or the channel creation option.', '/tutorial/group-profile-options.png'),
            s('Give the channel a name (e.g. "Assignments", "Announcements", "Q&A"). Multiple channels can exist within one group.', '/tutorial/create-channel.png'),
            s('Channels are optional   they extend a group with organized topics. Members can message in the main group and in any channel. Both students and faculty can create groups and channels.', '/tutorial/new-channel.png'),
          ],
        },
        {
          id: 'super-groups',
          title: 'How to Create a Super Group (Broadcast)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Broadcast announcements to large groups   only the creator can post.',
          steps: [
            s('Go to the "Groups" tab and tap the "Super Groups" sub-tab.', 'Screenshot: Super Groups tab'),
            s('Tap "+" to create a Super Group. Add members and post your announcement. Only you (the creator) can post   members receive and read but cannot reply.', '/tutorial/super-group-empty.png'),
            s('Super Groups are ideal for institution-wide or department-wide announcements that should not have reply threads.', '/tutorial/create-super-group.png'),
          ],
        },
      ],
    },
    {
      id: 'drawers',
      title: 'Drawers   Media Organizer',
      description: 'Create personal folders to organize media from any conversation.',
      intro: 'Drawers are your personal media library inside UNILinkd. As files, lecture slides, PDFs, and images get shared across many different chats   DMs, groups, classrooms, and clubs   they get buried in conversation history and are hard to retrieve. Drawers let you create named folders and save any received file into them with a single tap, creating a private organized archive across all your conversations.',
      articles: [
        {
          id: 'use-drawers',
          title: 'How to Use Drawers',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Save and organize files, images, and documents from multiple chats into named folders.',
          steps: [
            s('Drawers are personal pseudo-folders where you can save media from any chat   DMs, groups, classrooms, or clubs. They are private to you.'),
            s('Open the side drawer (☰) and tap "Drawers". You will see your existing drawers (folders) here.', '/tutorial/side-nav-mobile.png'),
            s('To create a drawer, tap "+" and give it a name (e.g. "Lecture Notes", "Lab Reports", "Club Photos").', '/tutorial/drawer-empty.png'),
            s('To save a file to a drawer: in any chat, long-press the file or image   tap "Save to Drawer"   choose the drawer.', '/tutorial/create-drawer.png'),
            s('Open a drawer to see all saved media from across all your conversations, organized in one place. You can search within a drawer too.', '/tutorial/drawer-created.png'),
          ],
        },
      ],
    },
    {
      id: 'conversations',
      title: 'Departmental & Campus Announcements',
      description: 'Post announcements (Faculty) or read them (Students)   three structured broadcast channels.',
      intro: 'UNILinkd replaces college broadcast lists, WhatsApp groups, and email chains with three structured announcement channels. Department messages reach only a specific academic batch. Bulletin announcements go to everyone on campus. Private messages are system-generated notifications sent directly to specific users. Only faculty and admins can post in any of these channels   students receive and read but cannot reply.',
      articles: [
        {
          id: 'department-announcements',
          title: 'How to Post a Department Announcement (Faculty)',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Send a message visible to all members of a department.',
          steps: [
            s('The app has three types of institutional conversations: Departments (for one department), Bulletin (for all campus), and Private (CSV-based personal messages). Only faculty can post in any of these.'),
            s('To post in a department, navigate to the Departments section and select the department you are a member of.'),
            s('Type your announcement and tap Send. All members of that department will receive it. Students can read but cannot post.'),
          ],
        },
        {
          id: 'bulletin-announcements',
          title: 'How to Post a Campus-Wide Bulletin (Faculty)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Broadcast a message to everyone at your institution.',
          steps: [
            s('Navigate to the Bulletin section in the app.'),
            s('Tap "Post Announcement" and write your message. Only faculty and admins can post to Bulletin.'),
            s('Tap Send. All students and staff at your institution will receive this announcement.'),
          ],
        },
        {
          id: 'read-announcements',
          title: 'How to Read Announcements (Students)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Find departmental and campus-wide messages from your faculty.',
          steps: [
            s('There are two types of institutional announcements you receive as a student: Department announcements (from your department\'s faculty) and Bulletin (campus-wide from any faculty).'),
            s('Find them in the Departments and Bulletin sections. You can read all announcements but cannot reply   only faculty and admins can post.'),
            s('You may also receive Private messages   system-generated notifications sent directly by your institution (e.g. fee reminders, event notices). You cannot reply to these either.'),
          ],
        },
      ],
    },
    {
      id: 'notes',
      title: 'Notes',
      description: 'Faculty create and share note sets; students unlock them with an access code.',
      intro: 'The Notes module connects faculty-uploaded study material with students who need it. Faculty create "Note Sets"   collections of PDFs, slides, or images   and share them via a private access code. Students enter the code once to permanently unlock that set and download files anytime. This replaces sending files in group chats, where they get buried. Multiple note sets from different professors can be unlocked with different codes.',
      articles: [
        {
          id: 'create-notes',
          title: 'How to Create and Share Notes (Faculty)',
          difficulty: 'Easy',
          time: '4 min',
          desc: 'Upload study material and generate a code for students to access it.',
          video: false,
          steps: [
            s('Tap the "Library" tab   "Notes"   "Manage" (faculty-only tab).', '/tutorial/notes1.png'),
            s('Tap "Add Notes". Enter your notes code and your notes URL', '/tutorial/notes3.png'),
            s('Once created, a unique Note Code is generated for that set. Share this code with your students   they enter it in the app to access your notes.'),
            s('You can view, update, or delete your note sets from the Manage tab at any time.'),
          ],
        },
        {
          id: 'access-notes',
          title: 'How to Access Notes Using a Note Code (Students)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Use a code shared by your professor to unlock their note collection.',
          steps: [
            s('Your professor will share a Note Code with you (e.g. via classroom chat or verbally). This code unlocks their specific set of uploaded notes.', '/tutorial/notes1.png'),
            s('Tap "Library"   "Notes". Tap "Enter Note Code" and type in the code your professor gave you.'),
            s('The note set unlocks. You can browse all files, preview them, and download for offline reading.'),
            s('You can access multiple note sets by entering different codes from different professors.'),
          ],
        },
      ],
    },
    {
      id: 'clubs',
      title: 'Clubs',
      description: 'Faculty create clubs; students discover and join them freely.',
      intro: 'Clubs are UNILinkd\'s community spaces   each one is an interest-based board for your entire institution, similar to a university-wide Reddit (Coding Club, Photography Society, Debate Club, etc.). Only Faculty can create clubs. Once created, students discover and join clubs freely. As a student, you can post and comment depending on the club\'s settings. As faculty, you control permissions, can pin posts, and moderate content. All club posts expire automatically after 6 months.',
      articles: [
        {
          id: 'create-club',
          title: 'How to Create a Club (Faculty)',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Set up a new campus club visible to all students.',
          steps: [
            s('Tap the "Clubs" tab. As faculty, you will see a "+" button in the bottom-right. Students do not see this button.', '/tutorial/club1.png'),
            s('Tap "+" and fill in the club name, description, and cover image.', '/tutorial/club2.png'),
            s('Set member permissions: toggle whether subscribers can post or comment in the club. You can change this later.'),
            s('Tap "Create". The club appears in the Clubs tab for all users at your institution. Club posts are automatically removed after 6 months.'),
          ],
        },
        {
          id: 'post-in-club',
          title: 'How to Post in a Club (Faculty)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Publish posts with text, images, or videos inside a club you manage.',
          steps: [
            s('Open a club you manage. Tap "+". Please note as a student , you must be subscribed to the club'),
            s('Write your post text. Attach images or a video if needed   you can attach multiple files.', '/tutorial/club4.png'),
            s('Tap "Post". All club members see the new post. You can pin (highlight) important posts from the post options.'),
          ],
        },
        {
          id: 'browse-join-clubs',
          title: 'How to Browse and Join Clubs (Students)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Discover clubs at your institution and become a member.',
          steps: [
            s('Tap the "Clubs" tab to see all clubs active at your institution.', '/tutorial/club3.png'),
            s('Clubs are like a university-wide Reddit   each club has posts, discussions, and a community around a topic (art, tech, sports, etc.). Posts stay for 6 months before they are automatically cleared.'),
            s('Tap "Join" on any club to become a member. Depending on the club settings, you may be able to post and comment.'),
          ],
        },
      ],
    },
    {
      id: 'classrooms',
      title: 'Classrooms',
      description: 'Incharge teachers manage class sessions and GMeets; students access their class chat and timetable.',
      intro: 'Classrooms are set up by your institution\'s admins on the web dashboard. Faculty are assigned as incharge teachers; students are assigned automatically. Each classroom has a group chat for real-time communication between teacher and students, a weekly timetable, and shared resources. Faculty can additionally create Google Meet sessions that are shared only with classroom students. This replaces separate WhatsApp groups and physical timetable sheets for every class. Faculty can also open a dedicated Teaching Schedule to see every class they are assigned to teach across all their classrooms in one place.',
      articles: [
        {
          id: 'access-classroom',
          title: 'How to Access Your Classroom (Faculty)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Open a classroom you have been assigned to as the incharge teacher.',
          steps: [
            s('Classrooms are created from the web dashboard by Admins. You will be assigned as the incharge faculty. Once assigned, the classroom appears in your app.', '/tutorial/main-screen-mobile.png'),
            s('Tap "Library"   "Classrooms". Your assigned classrooms are listed here.', '/tutorial/browse-classroom.png'),
            s('Open a classroom to see its students, channels, timetable, and options to create a GMeet or export student information. If a subject teacher was assigned to a period on the dashboard, their name is shown alongside the subject in the calendar too.', '/tutorial/gmeet-classroom.png'),
          ],
        },
        {
          id: 'create-gmeet',
          title: 'How to Create a Google Meet Session for Your Classroom',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Start an online class that only your classroom students can join.',
          steps: [
            s('Open your classroom in the app and tap the video icon with "+" icon or the meeting option.', '/tutorial/classroom-screen.png'),
            s('A Google Meet link is generated and shared automatically with all students in that classroom. Only students in the classroom will receive the link.', '/tutorial/gmeet-classroom.png'),
            s('Faculty and Sub-Admins can create and delete Meet sessions. Super Admins and Admins can also manage meetings.'),
          ],
        },
        {
          id: 'view-classroom-student',
          title: 'How to Access Your Classroom (Students)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Find your classroom and view the timetable and class chat.',
          steps: [
            s('Classrooms are created by your college admins and you are automatically added to your assigned classroom.', '/tutorial/main-screen-mobile.png'),
            s('Tap "Classrooms"'),
            s('Open your classroom to see the class chat (message your teacher and classmates here), the timetable, and any resources shared by the incharge teacher. If a subject teacher was assigned to a period, their name is shown alongside the subject.', '/tutorial/browse-classroom.png'),
            s('If your teacher shares a Google Meet link, you will receive it directly in the classroom chat. The meet will also be added to your google calendar automatically'),
          ],
        },
        {
          id: 'teaching-schedule-mobile',
          title: 'How to View Your Teaching Schedule',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'See every class you are assigned to teach across all your classrooms, in one weekly calendar.',
          steps: [
            s('Tap "Library" and look for the "Teaching Schedule" card. This only appears for Faculty accounts.', 'Screenshot: Teaching Schedule card in the Library tab'),
            s('Your schedule is shown as a weekly calendar with hours down the side and days across the top   the same view as the web dashboard. Each class is color-coded by classroom.', 'Screenshot: Weekly Teaching Schedule calendar on mobile'),
            s('If you open this screen without internet, you will see a "Showing a locally saved copy" banner and your last-synced schedule instead of an error.'),
            s('Tap the download icon in the top bar to explicitly "Save offline copy" before you expect to lose signal, so your latest schedule is always available even when offline.', 'Screenshot: Save offline copy button in the top bar'),
            s('If you are scheduled in two different classrooms at an overlapping time, both classes are merged into one red cell labeled "N clashing classes". Tap it to expand and see the full detail, then tap again to collapse.'),
            s('Viewing a colleague\'s schedule is only available on the web dashboard, not in the app.'),
          ],
        },
      ],
    },
    {
      id: 'subjects',
      title: 'Subjects',
      description: 'Browse your institution\'s subject list   read-only, used across attendance and timetables.',
      intro: 'Subjects are managed centrally by your institution\'s admins on the web dashboard. On the app, both faculty and students can browse the same list   useful for double-checking a subject\'s exact code or name. You cannot add, edit, or delete subjects from the app.',
      articles: [
        {
          id: 'browse-subjects',
          title: 'How to Browse Subjects',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Look up any subject code or name registered at your institution.',
          steps: [
            s('Tap the "Library" tab, then "Subjects".', 'Screenshot: Library tab with Subjects entry'),
            s('Search by code or name, or scroll the list and tap "Load more" for additional results.', 'Screenshot: Subjects search and list'),
            s('Tap any subject to see its full details   code, who added it, and when.'),
            s('This list is read-only on the app. To add, edit, or remove a subject, an Admin or Sub-Admin needs to do it from the web dashboard.'),
          ],
        },
      ],
    },
    {
      id: 'attendance',
      title: 'Attendance',
      description: 'Faculty take attendance per classroom and subject; students see their own report update instantly.',
      intro: 'Attendance is tied to real classrooms, subjects, and lecture dates   not a generic daily mark. Faculty take attendance for a specific classroom and subject each time they teach, and every student in that class sees their attendance update immediately in their own subject-wise report. Students can only view their own attendance, not edit it; if something looks wrong, they need to contact the faculty member who took that lecture.',
      articles: [
        {
          id: 'take-attendance-mobile',
          title: 'How to Take Attendance (Faculty)',
          difficulty: 'Medium',
          time: '4 min',
          desc: 'Mark a class present/absent for a classroom, subject, and date, right from your phone.',
          related: [ 'review-export-attendance-mobile' ],
          steps: [
            s('Tap the "Library" tab, then "Attendance Registry". This only appears for Faculty accounts.', 'Screenshot: Library tab with Attendance Registry entry'),
            s('Tap the "Take Attendance" button.', 'Screenshot: Take Attendance floating button'),
            s('Select the classroom, then select the subject you are teaching   subjects are searchable by code or name from your institution\'s Subject Registry.', 'Screenshot: Classroom and subject pickers'),
            s('Pick the lecture date (defaults to today) and optionally enter a period.'),
            s('The class roster appears. Use "Mark all present" or "Mark all absent" as a starting point, then search by name or ID and tick individual students to correct it.', 'Screenshot: Roster with present/absent checkboxes'),
            s('Tap "Submit Attendance". If you are offline or submission fails, it is saved as a draft on your device and you can retry it later   nothing is lost.'),
          ],
        },
        {
          id: 'review-export-attendance-mobile',
          title: 'How to Review and Export Your Attendance Registers (Faculty)',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Filter past registers you\'ve taken, fix a mistake, or export them to a file.',
          related: [ 'take-attendance-mobile' ],
          steps: [
            s('Open "Attendance Registry" from the Library tab. You will see summary stats and every register you\'ve personally taken, filterable by classroom, subject, and date range.', 'Screenshot: Attendance Registry list and filters'),
            s('Tap any register to view its full roster, or the sync icon to retry a register that failed to sync.'),
            s('To fix a mistake, open the register, tap Edit, adjust the classroom, subject, date, or individual marks, and save.'),
            s('Tap the export icon (top right) to request a CSV/Excel export for a classroom, subject, or date range   you\'ll get an email with a download link once it\'s ready (valid for 2 days).'),
            s('The drafts icon shows any registers that failed to submit and are waiting to retry   tap it to resend them once you\'re back online.'),
          ],
        },
        {
          id: 'view-attendance',
          title: 'How to View Your Attendance (Students)',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Check your overall percentage and a subject-by-subject breakdown.',
          steps: [
            s('Tap the "Library" tab, then "Attendance".', 'Screenshot: Library tab with Attendance entry'),
            s('The Overview tab shows your overall attendance percentage, plus how many lectures you attended, missed, and how many were conducted.', 'Screenshot: Attendance Tracker Overview tab'),
            s('Switch to the Subjects tab for a per-subject breakdown   attended, conducted, and percentage for each subject you are enrolled in.', 'Screenshot: Attendance Tracker Subjects tab'),
            s('You can hide a subject from your own overview using the toggle on its card if you don\'t want it counted   tap "UPDATE" to save the change.'),
            s('If your attendance looks wrong, contact the faculty member who took that lecture   records are entered by them, not by you.'),
          ],
        },
      ],
    },
    {
      id: 'placements',
      title: 'Placement Portal',
      description: 'Students browse and apply for jobs; faculty monitor all listings.',
      intro: 'The Placement Portal is your institution\'s managed job board. Placement coordinators post verified full-time and internship listings from the web dashboard. Students can browse, filter, apply, and track their application status directly from the app. Faculty can view all active listings to monitor opportunities for their students. Job creation and management is handled from the web dashboard, not the app.',
      articles: [
        {
          id: 'browse-apply-jobs',
          title: 'How to Browse and Apply for Jobs (Students)',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Find opportunities and apply through the Placement Portal.',
          steps: [
            s('Tap "Library"   "Placement Portal". Only Onboarded students can access this.', '/tutorial/library-nav.png'),
            s('Browse listings   filter by employment type (full-time, internship), work mode (remote, on-site, hybrid), or category.', '/tutorial/placements.png'),
            s('Tap a listing to read the full details. Tap "Apply" to submit your application.'),
            s('Track your submissions in "My Applications"   you can see the status and withdraw an application if needed.'),
            s('If you cannot access the portal or apply, ask your faculty admin to check your placement access status   it may have been revoked.'),
          ],
        },
        {
          id: 'view-placements-faculty',
          title: 'Placement Portal   Faculty Overview',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Browse and monitor placement listings for your students.',
          steps: [
            s('Placements can only be managed via online UNILinkd Dashboard .'),
          ],
        },
      ],
    },
    {
      id: 'library',
      title: 'E-Library, Campus Library & Documents',
      description: 'Access UNILinkd\'s digital book collection, your institution\'s physical library catalog, and your own documents.',
      intro: 'The Library tab has three distinct areas. The E-Library is UNILinkd\'s own digital content platform   a curated collection of free and paid books available to any UNILinkd user, permanently. Even after a student graduates, they keep access to any content they purchased on the E-Library   it stays with the account, not the institution. The Campus Library is your institution\'s physical book catalog, managed by your Librarian, searchable by genre, author, or subject to check availability before visiting in person. Documents is where you self-serve download certificates and letters your institution has made available to you   your name, email, and ID fill in automatically.',
      articles: [
        {
          id: 'library-overview',
          title: 'E-Library vs Campus Library   What\'s the Difference?',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Learn the difference between the two library sections.',
          steps: [
            s('The app has two distinct library sections: E-Library and Campus Library.'),
            s('E-Library is UNILinkd\'s own collection of books and resources   free and paid PDFs available to all users. This is not tied to your institution. Users who purchase content on E-Library can access it even after they graduate or leave the institution.', '/tutorial/library-nav.png'),
            s('Campus Library is your institution\'s physical library catalog. Students can search for books available at your campus by genre, author, or subject and check availability. Books in this catalog are managed by your Librarian.', '/tutorial/campus-lib.png'),
          ],
        },
        {
          id: 'documents-overview',
          title: 'How to Find and Download Your Documents',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Self-serve download certificates and letters your institution has made available to you.',
          related: [ 'library-overview' ],
          steps: [
            s('Open the "Library" tab at the bottom of the app, then tap "Documents".', '/tutorial/document-mobile-1.png'),
            s('You will see a search bar for finding a document by name   search only runs when you tap the search icon or submit, not as you type. Below it, a paginated list of documents currently available to you.', '/tutorial/document-mobile-2.png'),
            s('Tap a document to open it. Your name, email, and ID fill in automatically wherever the template uses those fields.'),
            s('Tap "Download to Device" to save a PDF copy, or use the Print/Share options in the preview to print or share it directly.'),
            s('If a document you were expecting isn\'t in the list, your account may not have been granted access to it yet   check with your institution\'s admin.'),
          ],
        },
      ],
    },
    {
      id: 'uniai',
      title: 'UniAI   AI Tools',
      description: 'Built-in AI for faculty content creation, student study support, and institution Q&A.',
      intro: 'UniAI is UNILinkd\'s built-in AI assistant, available to all users directly inside the app. Faculty use it most for drafting announcements, summarizing long documents, and generating teaching content. Students use it most for explaining difficult concepts, summarizing chapters, and generating mock exam questions for any subject. UniAI also has a "Guide" mode   ask it about your institution\'s own published announcements, deadlines, policies, and facilities, and it answers using only what your Admin has actually posted, not a general-purpose guess. No external subscription or separate app is needed   UniAI is available to every registered user.',
      articles: [
        //{
        //  id: 'use-uniai-faculty',
        //  title: 'How to Use UniAI (Faculty)',
        //  difficulty: 'Easy',
        //  time: '3 min',
        //  desc: 'Chat with UniAI, generate mock exams, and summarise content.',
        //  steps: [
        //    s('Open the side drawer (☰) and tap "UniAI".', 'Screenshot: UniAI option in the side drawer'),
        //    s('Chat with the AI to draft announcements, summarize documents, get teaching ideas, or answer subject questions.', 'Screenshot: UniAI chat interface with a faculty question'),
        //    s('Tap "Mock Exam" to generate practice questions. Enter the subject or topic and the number of questions, then tap "Generate".', 'Screenshot: Mock exam generator with topic input and Generate button'),
        //  ],
        //},
        {
          id: 'use-uniai-student',
          title: 'How to Use UniAI',
          difficulty: 'Easy',
          time: '3 min',
          desc: 'Chat with AI, take mock exams, and get exam prep help.',
          steps: [
            s('Open the side drawer (☰) and tap "UniAI".', '/tutorial/side-nav-mobile.png'),
            s('Chat freely   ask UniAI to explain a concept, summarize a chapter, or help you understand a topic. Share documents and it can summarize them for you.', '/tutorial/uni-ai.png'),
            s('Tap "Mock Exam" to take a practice test. Enter your subject or topic and the number of questions. Tap "Generate".'),
            s('Attempt the questions and submit. See your score and review the correct answers to identify gaps.'),
          ],
        },
        {
          id: 'use-ai-guide-mode',
          title: 'How to Use Guide Mode for News & Info',
          difficulty: 'Easy',
          time: '2 min',
          desc: 'Ask UniAI about institution announcements, deadlines, and general policies.',
          related: [ 'use-uniai-student' ],
          steps: [
            s('Open the side drawer (☰) and tap "UniAI".', '/tutorial/side-nav-mobile.png'),
            s('At the top, select "Guide" mode from the mode selector.', '/tutorial/ai-guide-mob.png'),
            s('Ask about anything your institution has published   recent announcements and deadlines (News & Updates), or facilities, policies, and contacts (General Info). Answers come only from what your Admin has actually published, so if something isn\'t covered yet, UniAI will say so rather than guess.'),
            s('Guide mode questions are answered fresh each time and are not saved to your regular chat history.'),
          ],
        },
      ],
    },
  ],
};
